import Api from '@/services/Api'

// Slanje dokumenta (racun, otpremnica, ponuda, primka) e-mailom.
//
// PDF se slaze na ekranu - isti onaj koji ide u ispis - i salje se gotov,
// kodiran u base64. Posluzitelj ga ne crta ponovno, pa primatelj dobije
// doslovno ono sto je operater vidio.
export default {
  // {CompanyId, documentId, pdf, na?, kopija?, predmet?, tekst?, UserId, Useremail}
  posalji (podaci) {
    return Api().post('dokument/mail', podaci)
  },
  // {CompanyId, documentId?, BusinessYear?}
  evidencija (query) {
    return Api().get('dokument/mail', {params: query})
  }
}
